import { Component, EventEmitter, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-information-agreement-employee-en',
  templateUrl: './information-agreement-employee.component.html',
  styleUrls: ['./information-agreement-employee.component.scss']
})
export class InformationAgreementEmployeeComponent implements OnInit {

  @Output()
  accept = new EventEmitter();

  accepted = false;
  companyAccepted = false;
  medicalConsultantAccepted = false;

  constructor() { }

  ngOnInit(): void {
  }

  public allAccepted = () => {
    return this.accepted && this.companyAccepted && this.medicalConsultantAccepted;
  }
  public onAccept = () => {
    this.accept.emit();
  }
}
